import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";

export const checkout = async ({body, id, forwardShippingPrice, returnShippingPrice}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.post(`${api.checkout}`, body, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {id, forwardShippingPrice, returnShippingPrice},
        })
    } catch (error) {
        console.error("Error fetching book details:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `itemAdd`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await checkout({body, id, forwardShippingPrice, returnShippingPrice});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}